import React from 'react'
import { Link, useLocation } from 'react-router-dom'
import { ChevronRightIcon } from '@heroicons/react/24/outline'
import BackButton from './BackButton'
import { useTranslation } from 'react-i18next'

// Slugi w adresach są bez polskich znaków, a fallback poniżej zamienia tylko
// myślniki na spacje — bez wpisu w tej mapie okruszek pokazuje „dobor zestawu pv".
// Problem jest systemowy, nie dotyczył samych ładowarek: mapa musi obejmować
// KAŻDY segment ścieżki, który może trafić do okruszków.
// Polskie nazwy i tłumaczenia leżą w lista:okruszki.trasa.<segment>.
const ROUTE_LABELS = new Set([
  'panele', 'panel', 'inwertery', 'inwerter', 'magazyny', 'magazyn', 'ladowarki',
  'ladowarka', 'dobor-ladowarki', 'model', 'obserwowane', 'porownanie', 'kompatybilnosc',
  'dobor-zestawu-pv', 'potwierdzenie-zestawu', 'wybor-wykonawcy', 'dodaj-siebie',
  'zostan-wykonawca', 'baza-wiedzy', 'regulamin', 'polityka-prywatnosci', 'rejestracja',
  'logowanie', 'reset-hasla',
])

const crumbLink =
  'px-2.5 py-1.5 rounded-md text-gray-500 hover:text-blue-600 hover:bg-gray-50 transition-colors'
const crumbCurrent =
  'px-2.5 py-1.5 text-blue-600 font-semibold truncate max-w-[60vw] sm:max-w-[420px]'

const Sep = () => (
  <ChevronRightIcon className="w-4 h-4 text-gray-300 flex-shrink-0 mx-0.5" />
)

const BreadcrumbsComponent = ({ parentLabel, parentTo, currentLabel }) => {
  const { t } = useTranslation('lista')
  const location = useLocation()
  const hasCustomTrail = parentLabel && parentTo && currentLabel

  const trail = hasCustomTrail ? (
    <>
      <Link to="/" className={crumbLink}>{t('okruszki.strona_glowna')}</Link>
      <Sep />
      <Link to={parentTo} className={crumbLink}>{parentLabel}</Link>
      <Sep />
      <span className={crumbCurrent} title={currentLabel}>{currentLabel}</span>
    </>
  ) : (
    <>
      <Link to="/" className={crumbLink}>{t('okruszki.strona_glowna')}</Link>
      {location.pathname
        .split('/')
        .filter(Boolean)
        .map((value, index, arr) => {
          const to = `/${arr.slice(0, index + 1).join('/')}`
          const isLast = index === arr.length - 1
          const decoded = decodeURIComponent(value).replace(/-/g, ' ')
          const label = currentLabel && isLast ? currentLabel : (ROUTE_LABELS.has(value) ? t(`okruszki.trasa.${value}`) : decoded)
          return (
            <React.Fragment key={to}>
              <Sep />
              {isLast ? (
                <span className={crumbCurrent} title={label}>{label}</span>
              ) : (
                <Link to={to} className={crumbLink}>{label}</Link>
              )}
            </React.Fragment>
          )
        })}
    </>
  )

  return (
    <div className="flex items-center gap-3 flex-wrap min-w-0">
      <BackButton fallback={hasCustomTrail ? parentTo : '/'} />
      <nav aria-label="breadcrumb" className="flex items-center flex-wrap text-sm min-w-0">
        {trail}
      </nav>
    </div>
  )
}

export default BreadcrumbsComponent
